// Angular Imports
import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';

// 3rd Party Imports
import { CupertinoPane, CupertinoSettings } from 'cupertino-pane';

@Injectable({
  providedIn: 'root'
})
export class PanesService {

  private panes: CupertinoPane[] = [];

  private cupertinoPaneSettings: CupertinoSettings = {
    backdrop: true,
    fitHeight: true,
    bottomClose: true,
    fastSwipeClose: true,
    breaks: {
      middle: { enabled: true, height: 200, bounce: true },
      bottom: { enabled: true, height: 80 }
    }
  };

  constructor(
    private platform: Platform
  ) { }

  newModal(selector: string, parentElement: string = '') {
    // If no parentElement is given, set it, otherwise revert to the default
    if (parentElement) { this.cupertinoPaneSettings.parentElement = parentElement; }
    this.cupertinoPaneSettings.modal = true;
    const newPane = new CupertinoPane(selector, this.cupertinoPaneSettings);
    this.addPane(newPane);
    return newPane;
  }

  newPane(selector: string, parentElement: string = '') {

    // If no parentElement is given, set it, otherwise revert to the default
    if (parentElement) { this.cupertinoPaneSettings.parentElement = parentElement; }

    // console.log(this.platform.platforms());
    if (this.platform.is('android') || this.platform.is('ios')) {
      this.cupertinoPaneSettings.modal = false;
    } else {
      this.cupertinoPaneSettings.modal = true;
    }
    // console.log(this.cupertinoPaneSettings);

    const newPane = new CupertinoPane(selector, this.cupertinoPaneSettings);
    this.addPane(newPane);
    return newPane;

  }

  setParentElement(parentElement: string) {
    this.cupertinoPaneSettings.parentElement = parentElement;
  }

  setModal(modal: boolean) {
    this.cupertinoPaneSettings.modal = modal;
  }


  // Add a pane to the array
  addPane(pane: any) {
    this.panes.push(pane);
  }

  // Remove a pane from the array
  removePane(pane: any) {
    const index = this.panes.indexOf(pane);
    if (index !== -1) {
      this.panes.splice(index, 1);
    }
  }

  // Open a specific pane
  openPane(pane: any) {
    // console.log(this.panes);
    // Your code to open the pane goes here
    const foundPane = this.panes.find(p => p === pane);
    if (foundPane) {
      foundPane.present({ animate: true });
    }
    // this.carpentinoPane.present({ animate: true });
  }

  // Close a specific pane
  closePane(pane: any) {
    const foundPane = this.panes.find(p => p === pane);
    if (foundPane) {
      if (pane.isPanePresented()) {
        pane.destroy({ animate: true });
      }
    }
  }

  closeAllPanes(): number {
    let foundOpenPanes = 0;
    this.panes.forEach(pane => {
      if (pane.isPanePresented()) {
        foundOpenPanes++;
        pane.destroy({ animate: true });
      }
    });
    return foundOpenPanes;
  }

}